import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Bus, ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import api, { formatTL } from "@/lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const orderNo = params.get("order");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!orderNo) return;
    api.get(`/orders/by-number/${orderNo}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderNo]);

  return (
    <div data-testid="payment-success" className="container-max px-4 md:px-8 section-pad max-w-2xl text-center">
      <CheckCircle2 size={72} className="mx-auto text-emerald-600 mb-5" />
      <h1 className="font-display text-3xl md:text-4xl font-extrabold mb-3">Ödemeniz Başarıyla Alındı</h1>
      {orderNo && (
        <>
          <p className="text-slate-600 mb-2">Sipariş numaranız:</p>
          <div className="font-display text-2xl font-extrabold text-[#0077B6] mb-6">{orderNo}</div>
        </>
      )}
      {order && (
        <div className="bg-white rounded-2xl border border-slate-100 p-6 text-left text-sm space-y-2 mb-6">
          <div className="flex justify-between"><span className="text-slate-600">Toplam</span><span className="font-bold">{formatTL(order.total)}</span></div>
          <div className="flex justify-between"><span className="text-slate-600">Teslim alınacak otogar</span><span className="font-bold">{order.delivery?.otogar}</span></div>
          <div className="flex justify-between"><span className="text-slate-600">Durum</span><span className="font-bold text-emerald-700">Ödendi · Hazırlanmaya alınıyor</span></div>
        </div>
      )}
      <div className="bg-[#0077B6]/5 border border-[#0077B6]/20 rounded-2xl p-5 text-left text-sm mb-8">
        <div className="flex items-start gap-3">
          <Bus className="text-[#0077B6] mt-0.5" size={20} />
          <div>
            <div className="font-bold mb-1">Otogardan Teslim Bilgilendirmesi</div>
            <p className="text-slate-700">Siparişiniz aynı gün otobüsle yola çıkarılacak ve otogara ulaştığında WhatsApp ile bilgilendirileceksiniz. Lütfen otogarın bagaj/kargo bölümünden sipariş numaranız ile teslim alınız.</p>
          </div>
        </div>
      </div>
      <Link to="/" className="btn-primary">Anasayfaya Dön <ArrowRight size={16}/></Link>
    </div>
  );
}

export function PaymentFail() {
  const [params] = useSearchParams();
  const orderNo = params.get("order");
  return (
    <div data-testid="payment-fail" className="container-max px-4 md:px-8 section-pad max-w-2xl text-center">
      <XCircle size={72} className="mx-auto text-rose-600 mb-5" />
      <h1 className="font-display text-3xl md:text-4xl font-extrabold mb-3">Ödeme Tamamlanamadı</h1>
      <p className="text-slate-600 mb-2">Sipariş numaranız:</p>
      {orderNo && <div className="font-display text-2xl font-extrabold text-rose-600 mb-6">{orderNo}</div>}
      <p className="text-slate-600 mb-8">Ödemeniz işlenemedi. Banka tarafından reddedilmiş veya işlem iptal edilmiş olabilir. Tekrar denemek veya farklı bir ödeme yöntemi (Havale/EFT) seçmek için iletişime geçebilirsiniz.</p>
      <div className="flex gap-3 justify-center flex-wrap">
        <Link to="/sepet" className="btn-primary">Sepete Geri Dön</Link>
        <a href="https://wa.me/908503093581" target="_blank" rel="noreferrer" className="btn-secondary">WhatsApp Destek</a>
      </div>
    </div>
  );
}
